<script lang="ts">
	//Design system components
	import { Text, Button, toast } from '@Shelly/shelly-design-system';
	//Stores
	import { user_data } from 'src/stores/account/user';
import { app } from 'src/stores/session/native-bridge';
	//Services
	import { format } from 'svelte-i18n';
	import sha1 from 'crypto-js/sha1';
	import { postReq } from 'src/services/http';
	//Helpers
	import { capFirstChar } from 'src/helpers/utilities';
	import { applicationHostUrl } from 'src/helpers/account_helpers';
	import { navigateToLoqedLinking } from 'src/components/Lists/list-helpers';
	import { isRepoUser } from 'src/helpers/user_server_conditions';

	let loading = false;

	// Prepare the URL for the Loqed OAuth process
	const prepareUrl = (loqedHost: string) => {
		// Using different configuration for repo accounts
		const clientId = isRepoUser()
			? `${import.meta.env.VITE_LOQED_DEV_CLIENT_ID}`
			: `${import.meta.env.VITE_LOQED_CLIENT_ID}`;
		const loqedOauthUrl = isRepoUser()
			? `${import.meta.env.VITE_LOQED_DEV_OAUTH_URL}`
			: `${import.meta.env.VITE_LOQED_OAUTH_URL}`;
		const userId = $user_data.user_id;
		const hashedUser = sha1(userId).toString();

		// Url of the Loqed service to redirect from the OAuth process
		let redirectUri = `https://${loqedHost}.shelly.cloud:${import.meta.env.VITE_LOQED_PORT}/api/auth/`;

		// Url of the Shelly app to redirect after the OAuth process
		let appHost = applicationHostUrl(
			import.meta.env.DEV && !$app
				? 'http://' + window.location.host
				: import.meta.env.VITE_APP_BUCKET,
			'/#/settings/integrations/loqed',
		);

		console.log('App Host: ', appHost);

		localStorage.setItem('loqedHash', hashedUser);
		appHost = appHost + `?state=${hashedUser}`;

		let state = {
			userId: userId,
			callbackUri: appHost,
		};
		const jsonState = JSON.stringify(state);
		const encodedJsonState = btoa(jsonState);
		let url = `${loqedOauthUrl}?client_id=${clientId}&redirect_uri=${redirectUri}&response_type=code&state=${encodedJsonState}&scope=operate-locks%20list-locks%20create-webhooks%20list-webhooks`;

		// remove
		console.log('Loqed OAuth URL:', url);

		return url;
	};

	const handleButtonAssociate = async () => {
		loading = true;

		try {
			// Get the available loqed instance
			let res = await postReq('device/get_lock_instance', undefined);

			if (res?.isok) {
				const instance = res?.data?.inst;
				const url = prepareUrl(instance);
				navigateToLoqedLinking(url);
			}
		} catch (error) {
			console.error('cannot get Loqed instance', error);
			toast.open({
				type: 'danger',
				title: $format('error_global'),
			});
		} finally {
			loading = false;
		}
	};
</script>

<div class="d-flex flex-direction-column align-items-center">
	<Text element="h1" class="text-center mb-s"
		>{$format('text_add_loqed_device', {
			default: 'Add LOQED device',
		})}</Text
	>
	<Text class="text-center mb-l text-color-muted" styleType="body-small"
		>{$format('text_integrate_loqed_device', {
			default: 'Integrate your LOQED devices seamlessly.',
		})}
	</Text>

	<Button
		size="l"
		width="auto"
		variant="primary"
		{loading}
		icon="fas fa-arrow-up-right-from-square"
		on:click={() => {
			handleButtonAssociate();
		}}
	>
		{capFirstChar(
			$format('button_add_device', {
				default: 'Add device',
			}),
		)}
	</Button>
</div>
